import Config from './Config';
import axios from 'axios';
import UIString from '../assets/UIString';


const Util = {


    log(log) {
        console.log(log);
    },

    api_url: function (lang, req_url) {
        return '/' + lang + '/api/' + Config.API_VER + req_url;
    },

    page_url: function (lang, req_url) {
        return '/' + lang + req_url;
    },



    get_url_array: function () {
        return String(window.location.pathname).split('/');
    },

    get_url_lang: function () {
        return String(window.location.pathname).split('/')[1];
    },


    goto: function (v) {
        document.location.href = Config.PAGE_URL + v;
    },


    goto_page: function (req_url) {
        // document.location.href = '/'+lang+'/api/'+Config.API_VER+'/'+req_url;
        alert('Deprecated.');
    },

    navigate: function (lang, req_url) {
        document.location.href = '/' + lang + req_url;
    },



    new_page: function (v) {
        window.open(Config.PAGE_URL + v, "_blink");
    },


    goto_site: function (v) {
        document.location.href = v;
    },


    /*
    alert:function(v)
    {
        alert(v);
    },
 */
    is_not_empty_string: function (v) {
        if (
            (v == undefined) ||
            (v == null) ||
            (String(v).trim() == '')
        ) {
            return false;
        }


        return true;
    },


    is_valid_email: function (str) {
        if (
            (String(str).trim() == '') ||
            (!String(str)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
            )
        ) {
            return false;
        }


        return true;
    },


    is_valid_password: function (str) {
        if (String(str).match(/\s/)) {
            return false;
        }


        return true;
    },




    get_vcode: function () {


        if ((document.getElementById('__vcode')) && (document.getElementById('__vcode').value != undefined) && (document.getElementById('__vcode').value != null)) {
            return document.getElementById('__vcode').value;
        }


        return false;
    },


    get_birth_years: function () {


        var y = new Date().getFullYear();
        var ret = [];




        for (var i = parseInt(y) - 18; i >= (y - 100); i--) {
            ret.push({
                'str': i,
                'value': i
            });
        }


        return ret;


    },


    // get: function (url, param_list, dataHandler, errorHandler) {
    get: async function (url /*, dataHandler, errorHandler*/) {



        let ret = {
            result: false,
            data: {},
            error: 'NETWORK_ERROR'
        };



        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }

        // {withCredentials:false}{ withCredentials:true }
        //axios.defaults.withCredentials = true;


        //axios.get(url,{withCredentials: true } )
        await axios.get(url)
            .then(function (response) {




                console.log('118 response' + JSON.stringify(response.data));
                //alert( JSON.stringify(response) );
                //dataHandler(response.data.data);return;
                //if (response.data.data.result) {
                if (response.data.result) {


                    //if(response.data.data.user_type == 'ADMIN_USER')
                    //{
                    //    document.location.href = "/admin/home/dashboard";
                    //}else if(response.data.data.user_type == 'PARTNER')
                    //{
                    //    document.location.href = "/control/home/dashboard";
                    //}else{
                    //
                    //}

                    ret = {
                        result: true,
                        data: response.data.data
                    };

                    console.log('check 136');
                    console.log("[GET] return: ", ret);
                    //return ret;

                    //dataHandler(response.data.data);


                } else {
                    console.log('139 error');
                    //if (errorHandler != undefined) { errorHandler(response.data.error); }
                    /*
                     errorHandler( 
                         //response.data.type, 
                         {
                             error_code: response.data.error_code,
                             error: response.data.error,
                         }
                     );
                     */
                    // if( errorHandler != null ){errorHandler(response.data.error,response.data.error_message);}
                    //alert(response.data.data.error);return;
                    //if( errorHandler === null )
                    //errorHandler(response.data.data.error);
                    //alert(response.data.error_message);
                    //Util.alert(response.data.error_message,{icon:'FATAL'});
                    return;
                    if (typeof errorHandler === undefined) {
                        // Default error handler.


                        /* if (ErrorString[response.data.data.error] === undefined) {
                             Util.alert("Unknown error", { icon: 'FATAL' });
                         } else {
                             Util.alert(ErrorString[response.data.data.error], { redirect_to: 'TITLE' });
                         }
  */

                    } else {
                        //  errorHandler(response.data.data.error);
                    }
                }

                console.log("GET return: ", ret);console.log("[GET] UTIL RETURNS:  ", ret);
               // return ret;

            })
            .catch(function (error) {
                // Util.alert(UIString.NETWORK_ERROR);
                //  errorHandler(
                //     UIString[Util.get_lang()]['NETWORK_ERROR']
                // );

                return {
                    result: false,
                    data: {},
                    error: 'NETWORK_ERROR'
                };
            });
      //  console.log("GET return: ", ret);
      //  return ret;

      console.log('check 136>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ');
      console.log("[GET] UTIL RETURNS:  ", ret);
      return ret;
    },




    post: function (url, form, dataHandler, errorHandler) {
        // FormData();
        //form.append('email',email.trim());
        //form.append('password',password);
        axios.defaults.withCredentials = true;
        // axios.base
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',

            },
            //  withCredentials: true // Config.FLAG_REQUEST_SSL
        }






        axios.post(url, form,
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true // Config.FLAG_REQUEST_SSL
            })
            .then(function (response) {
                //alert( JSON.stringify(response) );
                //dataHandler(response.data.data);return;
                console.log('237 POST RESULT: ', response.data);
                if (response.data.result) {


                    //if(response.data.data.user_type == 'ADMIN_USER')
                    //{
                    //    document.location.href = "/admin/home/dashboard";
                    //}else if(response.data.data.user_type == 'PARTNER')
                    //{
                    //    document.location.href = "/control/home/dashboard";
                    //}else{
                    //
                    //}


                    dataHandler(response.data.data);


                } else {


                    // errorHandler(response.data.error,response.data.error_message);




                    //if ((response.data.error.message) && (String(response.data.error.message).trim != ''))
                    if ((response.data.error) && (String(response.data.error).trim != '')) {
                        errorHandler(response.data.error);
                    } else {
                        // errorHandler(UIString.ERROR_CODE + ' : ' + response.data.error.code);
                        errorHandler('ERROR: Please contact administrator.');
                    }


                    return;


                    //errorHandler(response.data.error,response.data.error_message);




                    //alert(response.data.data.error);return;
                    //if( errorHandler === null )
                    //errorHandler(response.data.data.error);
                    //alert(response.data.error_message);
                    //Util.alert(response.data.error_message,{icon:'FATAL'});
                    return;
                    if (typeof errorHandler === undefined) {
                        // Default error handler.
                        /*
                        if (ErrorString[response.data.data.error] === undefined) {
                            Util.alert("Unknown error", { icon: 'FATAL' });
                        } else {
                            Util.alert(ErrorString[response.data.data.error], { redirect_to: 'TITLE' });
                        }
                            */


                    } else {
                        errorHandler(response.data.data.error);
                    }
                }
            })
            .catch(function (error) {
                /*Util.alert(UIString.NETWORK_ERROR);*/
                //alert(UIString.NETWORK_ERROR);
                errorHandler(UIString.NETWORK_ERROR);
                return;
            });


    },


    upload: function (url, form, dataHandler, errorHandler) {


        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'//'application/x-www-form-urlencoded'
            },
            withCredentials: Config.FLAG_REQUEST_SSL
        }






        axios.post(url, form, config)
            .then(function (response) {


                if (response.data.result) {


                    dataHandler(response.data.data);


                } else {


                    if (typeof errorHandler === "undefined") {
                        // Default error handler.
                        /*
                        if (ErrorString[response.data.data.error] === "undefined") {
                            alert("Unknown error: " + response.data.data.error);
                        } else {
                            Util.alert(ErrorString[response.data.data.error]);
                        }
 */

                    } else {
                        errorHandler(response.data.data.error_code, response.data.data.error);
                    }
                }
            })
            .catch(function (error) {
                alert(UIString.NETWORK_ERROR);
            });


    },






















    post_form: function (url, form, dataHandler, errorHandler) {


        const config = {
            headers: {
                'Content-Type': 'multipart/form-data' //'application/x-www-form-urlencoded'
            },
            withCredentials: Config.FLAG_REQUEST_SSL
        }






        axios.post(url, form, config)
            .then(function (response) {


                if (response.data.result) {


                    dataHandler(response.data.data);


                } else {


                    if (typeof errorHandler === "undefined") {
                        // Default error handler.

                        /*if (ErrorString[response.data.data.error] === "undefined") {
                            alert("Unknown error: " + response.data.data.error);
                        } else {
                            Util.alert(ErrorString[response.data.data.error]);
                        }
    
    */
                    } else {
                        errorHandler(response.data.data.type, response.data.data.error);
                    }
                }
            })
            .catch(function (error) {
                alert(UIString.NETWORK_ERROR);
            });


    },















































    get_url_params: function () {
        var param_ret = new Array();
        var req_url = document.location.href;
        req_url = req_url.split('?');
        var param_str_array;
        if (req_url.length > 1) {


            param_str_array = req_url[1].split('&');


            param_str_array.forEach(function (item, index) {
                var item_vars = item.split('=');
                if (!((item_vars[0] === '') || (item_vars[1] === '') || (item_vars[1] === undefined))) {
                    //param_ret[ String(item_vars[0]) ] = String(item_vars[1]).trim();


                    //param_ret[item_vars[0]]=item_vars[1];
                    const item_str = String(item_vars[0]);
                    const item_value = item_vars[1];
                    param_ret[item_str] = item_vars[1];
                    //param_ret.push({ page: item_value });
                }
                // alert( param_ret_array[ item_vars[0] ] );
            });
            // alert( param_ret.length );


            return param_ret;
            /*
            var param_ret = new Array();
            var req_url = document.location.href;
            req_url = req_url.split('?');
            if( req_url.length > 1 )
            {
   
                var param_str_array = req_url[1].split('&');
                param_str_array.forEach( function(item){
                   
                    var item_vars = item.split('=');
   
                    if( !( (item_vars[0].trim() === '') && (item_vars[1].trim() === '') || (item_vars[1] === undefined ) ) )
                    {
                        param_ret[ item_vars[0] ] = item_vars[1];
   
                    }
   
                });
   
   
   
                return param_ret;
        */
        }






        return [];
    },






    param_form: function (data) {
        console.log('379 ' + JSON.stringify(data));
        var ret = {};
        data.forEach((item) => {
            ret[Object.keys(item)[0]] = Object.values(item)[0];
        });


        console.log('util 385: ' + JSON.stringify(ret));
        return ret;


    },




    url_param_array: function () {


        var url = String(document.location.href).trim().split('?');


        if (url.length > 1) {
            var ret_array = {};
            const url_items = url[1].split('&');
            url_items.forEach((item, index) => {
                var item_data = item.split('=');
                if ((item_data[0] !== undefined) && (item_data[1] !== undefined)) {
                    ret_array[item_data[0]] = item_data[1];
                }
            });


            return ret_array;
        }




        return {};


    },




    assert_empty: function (t) {
        if (String(t).trim() == '') { return false; }
        return true;
    },


    assert_regex: function (t, r) {
        if (!r.test(String(t).trim())) { return false; }
        return true;
    },


    is_number: function (t) {
        return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(String(t));
    },


    assoc_str: function (t_array, t_val) {
        for (var i = 0; i < t_array.length; i++) {
            if (t_array[i].value == t_val) {
                return t_array[i].str;
                break;
            }
        }


        return '';
    },




    load_page: function (page) {
        window.location.href = Config.BASE_URL + page;
    },



    nav_page: function (page) {

    },

    get_lang: function () {
        return window.location.pathname.split('/')[1];
    },

    no_special_chars: function (v) {

        if (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(v)) {
            return false;
        }

        return true;

    },

    url_params: function (v) {

        let query = '';
        let str = v.trim().split(' ');
        for (let i = 0; i < str.length; i++) {
            if (str[i].trim() != '') {
                if (query != '') { query = query + '+'; }
                query = query + str[i].trim();
            }
        }

        return query;

    },





}






export default Util;

